module.exports = __webpack_public_path__ + "media/xunidianchang.70679d45.mp4";